import { ComponentChild } from 'preact';
import { useState } from 'preact/hooks';
import { useTooltipControlled } from '../hooks/UNSAFE_useTooltip';

type Props = {
  max: number;
  value: number;
  isReadonly?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
  datatip?: string;
  ariaDescribedBy?: string;
  width: number;
};

export function useTooltipOrDatatip({
  max,
  value,
  isReadonly,
  isDisabled,
  tooltip,
  datatip,
  ariaDescribedBy,
  width
}: Props): {
  tooltipContent: ComponentChild;
  tooltipProps: Record<string, any>;
} {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const tooltipVariant = isReadonly && !isDisabled ? 'tooltip' : 'datatip';
  const disabled =
    isDisabled ||
    !((tooltipVariant === 'tooltip' && tooltip) || (tooltipVariant === 'datatip' && datatip));
  const datatipIndex = Math.max(1, Math.ceil(value));
  const offset =
    tooltipVariant === 'tooltip' ? 0 : ((datatipIndex - Math.ceil(max / 2)) * width) / max;

  const { tooltipContent, tooltipProps } = useTooltipControlled({
    text: tooltipVariant === 'tooltip' ? tooltip : datatip,
    isOpen,
    anchor: {
      x: 'element',
      y: 'element'
    },
    position: 'bottom',
    offset: {
      mainAxis: 8, // redwood tooltip design spec
      crossAxis: offset
    },
    isDisabled: disabled,
    onToggle: ({ value }) => setIsOpen(value),
    variant: tooltipVariant
  });

  tooltipProps['aria-describedby'] = [ariaDescribedBy, tooltipProps['aria-describedby']]
    .filter(Boolean)
    .join(' ');

  return {
    tooltipContent,
    tooltipProps
  };
}
